window.addEventListener("DOMContentLoaded", () => {
  const errors = document.querySelectorAll(".error");
  if (errors.length > 0) {
    const contactForm = document.querySelector(".mw_wp_form");
    if (contactForm) contactForm.classList.add("mw_wp_form_error");
    const contactFormSection = document.getElementById("contact");
    if (contactFormSection) {
      window.scrollTo(0, contactFormSection.getBoundingClientRect().top + 100);
    }
  }
  errors.forEach((error) => {
    error.previousElementSibling.style.backgroundColor = "#fdeae9";
  });
});
